import {ReadingCardComponent} from '../components/reading-card.component.js'

export const GospelsComponent = () => {
    return {
        view: () => {
            return m(ReadingCardComponent)
        }
    }
}